<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-7 col-xl-6">
        <div
          class="document-preview page"
          style="max-width: 800px; margin-left: auto; margin-right: auto; background-color: #fff; padding-bottom: 50px"
        >
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h1 class="mb-0">Overview</h1>
            <transition name="fade" appear>
              <c-button v-if="canUseRefine" :disabled="suggestedRevision && suggestedRevision.length > 0" @click="refineOverview" variant="none" class="btn btn-sm btn-outline-primary ms-auto">
                <i class="fas fa-magic me-1"></i> Refine
              </c-button>
            </transition>
          </div>
          <div v-if="!isSigned" class="collapse mt-4 p-3 border rounded" ref="overviewSuggestion" >
            <h5 class="text-secondary"><i class="fas fa-magic me-1"></i> Suggested Revision</h5>
            <div class="mb-3 mt-1" v-html="suggestedRevision"></div>
            <div class="mt-3">
              <c-button class="btn btn-sm btn-primary me-2" @click="applySuggestion">Apply</c-button>
              <button class="btn btn-sm btn-outline-secondary" @click="dismissSuggestion">Dismiss</button>
            </div>
          </div>
          <div v-html="opportunity.overview" v-if="isSigned"></div>
          <wysiwyg-inline :content="opportunity.overview" :save="saveOverview" v-if="!isSigned"></wysiwyg-inline>

          <h1>Our Process</h1>
          <div v-html="opportunity.process" v-if="isSigned"></div>
          <wysiwyg-inline :content="opportunity.process" :save="saveProcess" v-if="!isSigned"></wysiwyg-inline>

          <h1>Schedule</h1>
          <div v-html="opportunity.schedule" v-if="isSigned"></div>
          <wysiwyg-inline :content="opportunity.schedule" :save="saveSchedule" v-if="!isSigned"></wysiwyg-inline>

          <h1>Terms and Conditions</h1>
          <div v-html="opportunity.terms" v-if="isSigned"></div>
          <wysiwyg-inline :content="opportunity.terms" :save="saveTerms" v-if="!isSigned"></wysiwyg-inline>
        </div>
      </div>

      <div class="col-4 h-100" style="max-width: 700px">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-header-title">Timeline</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12"><label>Commencement Date</label></div>
                <div class="col-6 form-group form-group-material">
                  <small class="form-text text-muted">Within x from Payment</small>
                  <multiselect
                    :show-labels="false"
                    v-model="commencementLength"
                    :options="completionOptions"
                    label="text"
                    track-by="id"
                    placeholder="Select Length"
                    @select="commencementLengthSelected"
                    :disabled="isDisabled"
                  ></multiselect>
                </div>
                <div class="col-6 form-group form-group-material">
                  <small class="form-text text-muted">or specify a date</small>
                  <input name="expected" :value="opportunity.commencement_date" type="date" class="form-control" @input="saveCommencementDate" :disabled="isDisabled" />
                </div>
              </div>

              <div class="row" style="margin-top:20px;">
                <div class="col-12"><label>Completion Date</label></div>
                <div class="col-6 form-group form-group-material">
                  <small class="form-text text-muted">From commencement date</small>
                  <multiselect
                    :show-labels="false"
                    v-model="length"
                    :options="completionOptions"
                    label="text"
                    track-by="id"
                    placeholder="Select Length"
                    @select="lengthSelected"
                    :disabled="isDisabled"
                  ></multiselect>
                </div>
                <div class="col-6 form-group form-group-material">
                  <small class="form-text text-muted">or specify a date</small>
                  <input name="expected" :value="opportunity.completion_date" type="date" class="form-control" @input="saveCompletionDate" :disabled="isDisabled" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-6">
                  <h4 class="card-header-title">Payment Instalments</h4>
                </div>
                <div class="col-6 w-auto ms-auto">
                  <div class="btn-group btn-sm" role="group" aria-label="Basic radio toggle button group">
                    <input
                      type="radio"
                      class="btn-check btn-sm"
                      name="btnradio"
                      id="btnradio1"
                      autocomplete="off"
                      v-on:click="setInstalmentType('Percent')"
                      :checked="opportunity.instalment_type == 'Percent'"
                      :disabled="isDisabled"
                    />
                    <label class="btn btn-outline-secondary btn-sm" for="btnradio1">Percent</label>

                    <input
                      type="radio"
                      class="btn-check btn-sm"
                      name="btnradio"
                      id="btnradio2"
                      autocomplete="off"
                      v-on:click="setInstalmentType('Dollar')"
                      :checked="opportunity.instalment_type == 'Dollar'"
                      :disabled="isDisabled"
                    />
                    <label class="btn btn-outline-secondary btn-sm" for="btnradio2">Dollar</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div
                class="alert alert-warning"
                v-show="opportunity.instalment_type == 'Percent' && checkInstalmentsTotalPercent != 100"
              >
                <p v-show="checkInstalmentsTotalPercent < 100">
                  Instalments need to add up to 100%,
                  <strong>{{ 100 - checkInstalmentsTotalPercent }}%</strong>
                  remaining.
                </p>
                <p v-show="checkInstalmentsTotalPercent > 100">
                  Instalments over 100%.
                  <strong>{{ checkInstalmentsTotalPercent - 100 }}%</strong>
                  over.
                </p>
                <p v-show="isNaN(checkInstalmentsTotalPercent)">Instalments validation error</p>
              </div>

              <div
                class="alert alert-warning"
                v-show="opportunity.instalment_type == 'Dollar' && checkInstalmentsTotalDollar != costing.total_ex"
              >
                <p v-show="checkInstalmentsTotalDollar < costing.total_ex">
                  Instalments need to add up to ${{ costing.total_ex | currency }}
                  <br />
                  <strong>${{ (costing.total_ex - checkInstalmentsTotalDollar) | currency }}</strong>
                  remaining.
                </p>
                <p v-show="checkInstalmentsTotalDollar > costing.total_ex">
                  Instalments over ${{ costing.total_ex }}
                  <br />
                  <strong>${{ checkInstalmentsTotalDollar - costing.total_ex }}</strong>
                  over.
                </p>
              </div>

              <Instalment
                :initial-instalment="instalment"
                v-for="(instalment, index) in instalments"
                v-bind:key="instalment.id"
                :index="index"
                :is-last="index == instalments.length - 1"
                :type="opportunity.instalment_type"
              ></Instalment>
            </div>
            <div class="card-footer" v-if="!isDisabled">
              <div class="row">
                <div class="col-6">
                  <div class="input-group" v-if="opportunity.instalment_type == 'Percent'">
                    <input v-model="instalment.percent" type="number" class="form-control" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div class="input-group" v-if="opportunity.instalment_type == 'Dollar'">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input v-model="instalment.total_ex" type="number" step=".01" class="form-control" />
                  </div>
                </div>
                <div class="col-2">
                  <a href="#" class="btn btn-primary" @click="createInstalment">Add</a>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card -->
        </div>

        <documents></documents>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndex } from 'lodash'
import Multiselect from 'vue-multiselect'
import { WysiwygClassic, WysiwygInline } from 'components/form/input'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { SET_PROPERTY } from 'vx/mutations'

import Instalment from './instalments/Instalment.vue'
import Documents from './Documents'
import { Collapse } from 'bootstrap'
import { http, notify } from 'utils'

export default {
  components: {
    WysiwygClassic,
    WysiwygInline,
    Instalment,
    Multiselect,
    Documents,
  },

  data: function () {
    return {
      overviewSuggestionEl: null,
      suggestedRevision: null,
      template: null,
      instalment: {
        percent: null,
        days: 30,
        opportunity_id: null,
        total_ex: null,
      },
      completionOptions: [
        { id: 1, text: '1 Week' },
        { id: 2, text: '2 Weeks' },
        { id: 3, text: '3 Weeks' },
        { id: 4, text: '1 Month' },
        { id: 8, text: '2 Months' },
        { id: 12, text: '3 Months' },
        { id: 16, text: '4 Months' },
        { id: 20, text: '5 Months' },
        { id: 24, text: '6 Months' },
      ],
    }
  },

  computed: {
    ...mapState('opportunity', {
      opportunity: 'single',
    }),

    ...mapState('costing', {
      costing: 'costing',
    }),

    ...mapState('instalment', {
      instalments: 'list',
    }),

    ...mapGetters('opportunity', ['isSigned']),
    checkInstalmentsTotalPercent() {
      return this.instalments.reduce((a, b) => a + parseInt(b.percent), 0)
    },

    checkInstalmentsTotalDollar() {
      return this.instalments.reduce((a, b) => a + parseFloat(b.total_ex), 0)
    },

    length: {
      get() {
        if (this.opportunity && this.opportunity.length) {
          let existingItem = findIndex(this.completionOptions, (existing) => existing.id === this.opportunity.length)

          if (existingItem >= 0) {
            return this.completionOptions[existingItem]
          }
        }
        return null
      },
      set() {},
    },

    commencementLength: {
      get() {
        if (this.opportunity && this.opportunity.commencement_length) {
          let existingItem = findIndex(this.completionOptions, (existing) => existing.id === this.opportunity.commencement_length)

          if (existingItem >= 0) {
            return this.completionOptions[existingItem]
          }
        }
        return null
      },
      set() {},
    },

    isDisabled() {
      return this.isSigned || this.opportunity.approved_at != null
    },

    canUseRefine () {
      return !this.isSigned && (this.opportunity.overview ? this.opportunity.overview.length > 0 : false) && ['Draft', 'Pending Approval'].includes(this.opportunity.status)
    }
  },

  mounted() {
    this.getInstalments({ opportunity_id: this.opportunity.id })
  },

  methods: {
    ...mapMutations('opportunity', [SET_PROPERTY]),

    ...mapActions('opportunity', {
      updateOpportunity: 'updateSingle',
    }),

    ...mapActions('instalment', {
      addInstalment: 'addSingle',
      getInstalments: 'getList',
      updateInstalment: 'updateSingle',
    }),

    newValue(event) {
      return this.updateInstalment({
        id: event.target.dataset.instalment_id,
        payload: {
          percent: event.target.value,
        },
      })
    },

    async refineOverview () {
      try {
        const response = await http.post(`/opportunities/${this.opportunity.id}/overview/refine`)

        this.suggestedRevision = response.data.refinement

        if (!this.overviewSuggestionEl) {
          this.overviewSuggestionEl = new Collapse(this.$refs.overviewSuggestion, {
            toggle: true, // Don't auto-toggle on instantiation
          })
        }

        this.overviewSuggestionEl.toggle()

        return response
      } catch (e) {
        notify.error(e.response.data.message)
      }

    },

    async applySuggestion () {
      const response = await this.saveOverview(this.suggestedRevision)
      this[SET_PROPERTY]({ property: 'opportunity.single.overview', value: this.suggestedRevision })

      this.overviewSuggestionEl.toggle()

      return response
    },

    dismissSuggestion () {
      this.overviewSuggestionEl.toggle()
      this.suggestedRevision = null
    },

    createInstalment() {
      var data = {
        days: this.instalment.days,
        opportunity_id: this.opportunity.id,
      }

      if (this.opportunity.instalment_type == 'Percent') {
        data.percent = this.instalment.percent
      } else {
        data.total_ex = this.instalment.total_ex
      }

      return this.addInstalment(data).then(() => {
        //if (this.instalments.length > 2) {
        //	this.instalment.days = this.instalment.days + 30;
        //}
      })
    },

    saveOverview(data) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { overview: data },
      })
    },

    saveProcess(data) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { process: data },
      })
    },

    saveSchedule(data) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { schedule: data },
      })
    },

    saveTerms(data) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { terms: data },
      })
    },

    commencementLengthSelected(selected) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { commencement_length: selected.id, commencement_date: null },
      })
    },

    lengthSelected(selected) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { length: selected.id, completion_date: null },
      })
    },

    setInstalmentType(instalment_type) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: { instalment_type: instalment_type },
      })
    },

    saveCommencementDate(event) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: {
          commencement_length: null,
          commencement_date: event.target.value,
        },
      })
    },

    saveCompletionDate(event) {
      return this.updateOpportunity({
        id: this.opportunity.id,
        payload: {
          length: null,
          completion_date: event.target.value,
        },
      })
    },
  },
}
</script>
